import Service from "./Service";
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export class ChapterService extends Service{
    constructor() {
        super();
        this.baseURL = 'chapter';
    }

    findByCourseId(courseId) {
        return fetch(SERVER_URL + this.baseURL + '/findByCourseId/' + courseId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}